import React, { useContext } from 'react';
import { AtomSchemaType }    from '@geenee/shared/type/atom.type';

// create atom context
export const AtomContext = React.createContext<AtomSchemaType>(null);

export const useAtom = (): AtomSchemaType => useContext(AtomContext);
